﻿module.exports = {
    "id": "de",
    "label": "Deutsche",
    "rtl": false,

    "translations": {
        "INVALID_LINK_TITLE": "Link Ungültig.",
        "INVALID_LINK_TEXT": "Bitte nutzen Sie den \"Abmelden\"-Link in Ihrer E-Mail, um sich von unserer Mailing-Liste abzumelden.",
        "UNSUBSCRIBE_ARE_YOU_SURE": "Sind Sie sicher, dass Sie diese E-Mail-Adresse von unserer Mailing-Liste abmelden möchten?",
        "UNSUBSCRIBE_CLICK_CONFIRM": "Zur Bestätigung klicken Sie auf den \"Abmelden\" Button weiter unten.",
        "YOU_HAVE_BEEN_UNSUBSCRIBED": "Sie wurden erfolgreich von unserer Mailing-Liste <b>abgemeldet</b>.",
        "UNSUBSCRIBED_IN_ERROR": "Falls Sie sich versehentlich abgemeldet haben, klicken Sie bitte auf den <a href='/resubscribe' class='resubscribe'>Wieder anmelden</a> Link.",
        "CANCELLED_STILL_SUBSCRIBED": "<b>Vorgang abgebrochen.</b> Sie sind weiterhin in unserer Mailing-Liste <b>angemeldet</b>.",
        "THANK_YOU_FOR_CONTINUING": "Vielen Dank, dass Sie weiterhin an unseren Umfragen teilnehmen möchten.",
        "EMAIL_ALREADY_UNSUBSCRIBED": "Diese E-Mail-Adresse wurde bereits von unserer Mailing-Liste <b>abgemeldet</b>.",
        "CLICK_RESUBSCRIBE_TO_REJOIN": "Klicken Sie auf den \"Wieder Anmelden\" Button weiter unten, wenn Sie wieder in unsere Mailing-Liste aufgenommen werden möchten.",
        "YOU_HAVE_BEEN_RESUBSCRIBED": "Sie wurden in unsere Mailing-Liste erfolgreich <b>wieder aufgenommen</b>.",
        "YOU_ARE_ALREADY_SUBSCRIBED": "Sie sind bereits in unserer Mailing-Liste <b>angemeldet</b>.",
        "THANK_YOU_FOR_PARTICIPATING": "Vielen Dank, dass Sie an unseren Umfragen teilnehmen.",
        "CHECKING": "Überprüfung läuft...",
        "UNSUBSCRIBE": "Abmelden",
        "RESUBSCRIBE": "Wieder Anmelden",
        "EMAIL": "E-Mail",
        "CANCEL": "Abbrechen"
    }

};

